import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3024c8ba&scoped=true&lang=html&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3024c8ba",
  null
  
)

export default component.exports